module.exports = __webpack_public_path__ + "img/1453.9dce78aa.gif";